import React from 'react';
import PropTypes from 'prop-types';
import './ReSign.scss';
import PageHeader from '../PageHeader/PageHeader';

const ReSignWrapper = (props) => {
  const { title, children } = props;
  return (
    <main className="resign">
      <PageHeader title={title} />
      <div className="container">
        {children}
      </div>
    </main>
  );
};

ReSignWrapper.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired
};

export default ReSignWrapper;



/** WEBPACK FOOTER **
 ** ./src/components/ReSign/ReSignWrapper.js
 **/